import styled from "styled-components";

import { PlainTooltip } from "@similarweb/ui-components";

import type { Topic } from "../../../api-client/demandSearchTrendsTopicsAPI";

const TOOLTIP_LEVEL_SEPARATOR = " > ";
const DEBOUNCE_DELAY = 250;

const TextWrapper = styled.div`
    text-transform: capitalize;
`;

const getTooltipContent = (topic: Topic) => {
    const path = topic.Path.split("/");
    const content = path.map((name) => name.trim()).join(TOOLTIP_LEVEL_SEPARATOR);

    return <TextWrapper>{content}</TextWrapper>;
};

const getTooltipPlacement = (placement: "left" | "right") => {
    return placement === "left" ? "right" : "left";
};

type TopicsDiscoverAllTopicsModalMainSectionTopicsTopicGroupItemTooltipProps = {
    key: string;
    item: Topic;
    placement: "left" | "right";
    children: React.ReactNode;
};

export const TopicsDiscoverAllTopicsModalMainSectionTopicsTopicGroupItemTooltip = ({
    item,
    placement,
    children,
}: TopicsDiscoverAllTopicsModalMainSectionTopicsTopicGroupItemTooltipProps) => {
    return (
        <PlainTooltip
            debounce={DEBOUNCE_DELAY}
            placement={getTooltipPlacement(placement)}
            tooltipContent={getTooltipContent(item)}
        >
            {children}
        </PlainTooltip>
    );
};
